import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import BuildIcon from '@mui/icons-material/Build';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import getStyles from './styles';

const steps = [
  {
    icon: <CloudUploadIcon sx={{ fontSize: 40 }} />,
    title: 'Submit Content',
    description:
      'Provide your text, images, logo, and domain credentials. Countdown starts when we receive everything.',
    step: '1'
  },
  {
    icon: <BuildIcon sx={{ fontSize: 40 }} />,
    title: 'We Build Fast',
    description:
      'Our experts use optimized templates and workflows to ensure your website is ready in 2 days.',
    step: '2'
  },
  {
    icon: <RocketLaunchIcon sx={{ fontSize: 40 }} />,
    title: 'Go Live',
    description:
      'We publish your website on your domain with SSL and mobile-friendly design.',
    step: '3'
  },
  {
    icon: <CheckCircleIcon sx={{ fontSize: 40 }} />,
    title: 'Guaranteed Delivery',
    description:
      "If your website isn't live in 48 hours, you get a full refund.",
    step: '4'
  }
];

const MVPWorks = () => {
  const styles = getStyles();

  return (
    <Box component="section" sx={styles.section}>
      {/* Decorative blurred backgrounds */}
      <Box sx={styles.bgCircle1} />
      <Box sx={styles.bgCircle2} />

      <Container maxWidth="xl" sx={styles.container}>
        {/* Header */}
        <Box sx={styles.header}>
          <Typography variant="h2" sx={styles.title}>
            How It Works
          </Typography>
          <Typography variant="h3" sx={styles.subtitle}>
            Four simple steps to your new website
          </Typography>
        </Box>

        {/* Steps Grid */}
        <Grid container spacing={4} sx={styles.grid}>
          {steps.map((step, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Paper
                elevation={3}
                sx={{
                  ...styles.card,
                  animationDelay: `${index * 0.15}s`
                }}
              >
                <Box sx={styles.iconWrapper}>
                  <Box sx={styles.iconBox}>{step.icon}</Box>
                  <Box sx={styles.stepNumber}>{step.step}</Box>
                </Box>

                <Typography variant="h5" sx={styles.stepTitle}>
                  {step.title}
                </Typography>

                <Typography variant="body2" sx={styles.stepDescription}>
                  {step.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default MVPWorks;
